<div class="ce-content">
  <h3 class="sat-page-title">Store Attribute Types</h3>
  <p class="sat-page-description">
    Define attribute types and their allowed values. These appear as selectable fields in Store Management and as filter options in Version Search.
  </p>

  <ng-container *ngIf="viewModel$ | async as viewModel">
    <mat-progress-bar *ngIf="viewModel.isLoading" mode="indeterminate"></mat-progress-bar>

    <app-store-attribute-summary-cards [stats]="viewModel.stats"></app-store-attribute-summary-cards>

    <div class="categories-list" *ngIf="viewModel.categories.length; else noCategories">
      <app-store-attribute-category-accordion
        *ngFor="let category of viewModel.categories"
        [category]="category"
        [expanded]="isExpanded(category.id)"
        [filterToggleSavingId]="filterToggleSavingId"
        (expandedChange)="toggleCategory(category.id, $event)"
        (addType)="openAddAttributeTypeDialog($event.id)"
        (editCategory)="openEditCategoryDialog($event)"
        (manageValues)="openManageValuesDialog($event)"
        (deleteType)="deleteAttributeType($event)"
        (filterEnabledChange)="toggleFilterEnabled($event)">
      </app-store-attribute-category-accordion>
    </div>

    <ng-template #noCategories>
      <div class="no-records" *ngIf="!viewModel.isLoading">
        <h2>No categories found</h2>
        <p>Create a category to start defining store attribute types.</p>
      </div>
    </ng-template>
  </ng-container>
</div>
